import React, { useRef, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom';
import {
  Toolbar,
  Hidden,
  List,
  ListItem,
  IconButton,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Image, ActionButton } from 'components/atoms';
import LanguageButton from 'components/organisms/Language/LanguageButton';
import ArrowRight from "@material-ui/icons/ArrowRight";

// const loginUrl = process.env.REACT_APP_LOGIN_URL;
const loginUrl = 'https://fvv-al.ning.com/main/authorization/signIn?target=https%3A%2F%2Ffvv-al.ning.com%2F';
const lbmsUrl = 'https://smbv.fvv.al';
const searchUrl = './search?q=';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: "url('/assets/images/topbar-cover.svg')",
    position: 'relative',
  },
  flexGrow: {
    flexGrow: 1,
  },
  navigationContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: -16,
  },
  toolbar: {
    minHeight: 140,
    zIndex: 999,
    maxWidth: theme.layout.contentWidth + 700,
    width: '100%',
    margin: '0 auto',
    padding: theme.spacing(0, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 8),
    },
  },
  styleFixer: {
    width: 340,
    height: 10,
    display: 'hidden',
    [theme.breakpoints.down('md')]: {
      width: 0,
    },
  },
  menubar: {
    maxWidth: theme.layout.contentWidth,
    width: '100%',
    margin: '0 auto',
    padding: theme.spacing(0, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 8),
    },
  },
  navLink: {
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
  listItem: {
    cursor: 'pointer',
    borderRight: '0.5px solid #273A42',
    // boxShadow: '0.5px 0 #273a42',
    '&:hover > .menu-item, &:hover svg': {
      color: '#981B49',
    },
    '&.menu-item--no-dropdown': {
      paddingRight: 0,
    },
    '&:last-child': {
      borderRight: 0,
    },
    padding: 0,
  },
  listItemActive: {
    '&> .menu-item': {
      color: '#273A42',
      fontWeight: 'bold',
    },
  },
  linkItemActiveLink: {
    color: '#273A42',
    fontWeight: 'bold',
  },
  listItemText: {
    fontFamily: 'Roboto',
    fontSize: 17,
    color: '#273A42',
    flex: '0 0 auto',
    // marginRight: theme.spacing(2),
    whiteSpace: 'nowrap',
    padding: '10px 20px 10px 20px',

    '&:after': {
      content: '""',
      display: 'block',
      height: 3,
      borderRadius: 3,
      left: '50%',
      marginLeft: -28,
      bottom: -10,
      position: 'absolute',
      background: '#981B49',
      transition: 'width 0.3s ease 0s, left 0.3s ease 0s',
      width: 0,
      visibility: 'none',
      textAlign: 'center',
    },

    '&:hover:after': {
      width: 56,
      // width: 'calc(100% - ' + theme.spacing(4) + 'px)',
      // marginRight: theme.spacing(2),
      // marginLeft: theme.spacing(2),
      // left: 0,
      // left: '50%',
      // right: '50%',
      // left: '0',
      right: '0',
    },

    '&.menu-item-active-link:after': {
      width: 56,
    },
  },
  listItemTextSub: {
    fontFamily: 'Roboto',
    fontSize: 13,
    color: '#273A42',
    flex: '0 0 auto',
    // marginRight: theme.spacing(2),
    whiteSpace: 'nowrap',
    padding: '5px 10px',

    '&:after': {
      content: '""',
      display: 'block',
      height: 3,
      borderRadius: 3,
      left: '50%',
      marginLeft: -28,
      bottom: -10,
      position: 'absolute',
      background: '#981B49',
      transition: 'width 0.3s ease 0s, left 0.3s ease 0s',
      width: 0,
      visibility: 'none',
      textAlign: 'center',
    },

    '&:hover:after': {
      width: 56,
      // width: 'calc(100% - ' + theme.spacing(4) + 'px)',
      // marginRight: theme.spacing(2),
      // marginLeft: theme.spacing(2),
      // left: 0,
      // left: '50%',
      // right: '50%',
      // left: '0',
      right: '0',
    },

    '&.menu-item-active-link:after': {
      width: 56,
    },
  },
  listItemButton: {
    whiteSpace: 'nowrap',
  },
  listItemIcon: {
    minWidth: 'auto',
  },
  popover: {
    padding: theme.spacing(4),
    border: theme.spacing(2),
    boxShadow: '0 0.5rem 2rem 2px rgba(116, 123, 144, 0.09)',
    minWidth: 350,
    marginTop: theme.spacing(2),
  },
  iconButton: {
    // marginLeft: theme.spacing(2),
    padding: 0,
    '&:hover': {
      background: 'transparent',
    },
  },
  iconButtonLabel: {
    '& svg': {
      fontSize: 32,
    },
  },
  expandOpen: {
    transform: 'rotate(180deg)',
    color: theme.palette.primary.dark,
  },
  logoContainer: {
    width: '420px',
    position: 'absolute',
    top: 0,
    bottom: 0,
    margin: 'auto 0',
    // height: 28,
    [theme.breakpoints.down('lg')]: {
      left: '1%',
    },
    [theme.breakpoints.up('xl')]: {
      left: '4%',
    },
    [theme.breakpoints.up('xxl')]: {
      left: '10%',
    },
  },
  logoImage: {
    width: '420px',
    height: 'auto',
    display: 'inline-block',
    verticalAlign: 'middle',
    [theme.breakpoints.down('md')]: {
      width: '200px',
    },
    [theme.breakpoints.up('md')]: {
      width: '300px',
    },
  },
  parent: {
    position: 'absolute',
    height: '100%',
    whiteSpace: 'nowrap',
  },
  dummyChild: { height: '100%', display: 'inline-block', verticalAlign: 'middle' },
  menu: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  menuItem: {
    marginRight: theme.spacing(5),
    '&:last-child': {
      marginRight: 0,
    },
  },
  menuGroupItem: {
    paddingTop: 0,
  },
  menuGroupTitle: {
    textTransform: 'uppercase',
  },
  // bottomBorderMenu: {
  //   borderBottom: '3px solid #981B49',
  //   position: 'absolute',
  //   bottom: -10,
  //   left: '20%',
  //   right: '20%',
  // },
  searchButton: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: 15,
    marginLeft: 5,
    paddingLeft: 8,
    paddingRight: 8,
    color: '#981B49',
    backgroundColor: 'transparent',
    border: '2px solid #981B49',
    '&:hover': {
      color: 'white',
      backgroundColor: '#981B49',
    },
  },
  loginButton: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: 15,
    marginLeft: 5,
    paddingLeft: 8,
    paddingRight: 8,
    color: 'white',
    backgroundColor: '#981B49',
    border: '2px solid #981B49',
    '&:hover': {
      color: '#981B49',
      backgroundColor: 'transparent',
    },
  },
  languageButtonContainer: {
    width: 70,
    marginRight: -120,
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
    },
  },
  ministryLogoContainer: {
    height: 95,
    marginRight: 50,
  },
  lbmsButton: {
    backgroundColor: '#0049a8',
    border: '2px solid #0049a8',
    paddingLeft: 8,
    paddingRight: 8,
    '&:hover': {
      color: '#0049a8',
      backgroundColor: 'transparent',
    },
  },
  subMenu: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: 'center'
  }
}));

const Topbar = ({ themeMode, themeToggler, onSidebarOpen, pages, className, ...rest }) => {
  const classes = useStyles();

  const { t } = useTranslation();

  // eslint-disable-next-line no-unused-vars
  const [anchorEl, setAnchorEl] = useState(null);
  const [openedPopoverId, setOpenedPopoverId] = useState(null);
  const [openSub, setOpenSub] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const anchorRef = useRef();
  const subAnchorRef = useRef();
  const location = useLocation();

  const handleClick = (event, popoverId) => {
    setAnchorEl(event.target);
    setOpenedPopoverId(popoverId);
  };

  const pagesList = Object.entries(pages).map(([key, value]) => {
    return value;
  });

  // Nested menu management
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
    setOpenSub(false);
  };

  // Nested sub menu management
  const handleToggleSub = () => {
    setOpenSub((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if ((anchorRef.current && anchorRef.current.contains(event.target)) || (subAnchorRef.current && subAnchorRef.current.contains(event.target))) {
      return;
    }
    setOpenSub(false);
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpenSub(false);
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
      setOpenSub(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  const prevOpenSub = React.useRef(openSub);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
      prevOpen.current = open;
    }

    if (prevOpenSub.current === true && openSub === false) {
      subAnchorRef.current.focus();
      prevOpenSub.current = openSub;
    }
  }, [open, openSub]);

  const isStatisticsNestedMenuActive = ['/financial-statistics', '/national-indicators', '/local-indicators'].includes(location.pathname);

  return (
    <div className={classes.root}>
      <div className={classes.logoContainer}>
        <div className={classes.parent}>
          <div className={classes.dummyChild}></div>
          <a href='/' title='Financat e Vetëqeverisjes Vendore'>
            <Image
              className={classes.logoImage}
              src={themeMode === 'light' ? '/assets/logo.png' : '/assets/logo.png'}
              alt='Financat e Vetëqeverisjes Vendore'
              lazy={false}
            />
          </a>
        </div>
      </div>
      <Toolbar disableGutters className={classes.toolbar} {...rest}>
        <div className={classes.flexGrow} />
        <div className={classes.ministryLogoContainer}>
          <Image src={'/assets/images/MinistryLogo.svg'} alt={'Ministria e Ekonomise dhe Financave'} lazy={false} />
        </div>
        <Hidden smDown>
          <div className={classes.languageButtonContainer}>
            <LanguageButton />
          </div>
        </Hidden>
        <div>
          <Hidden mdUp>
            <IconButton
              className={classes.iconButton}
              classes={{
                label: classes.iconButtonLabel,
              }}
              onClick={onSidebarOpen}
              aria-label='Menu'
            >
              <MenuIcon />
            </IconButton>
          </Hidden>
          <div className={classes.styleFixer}></div>
        </div>
      </Toolbar>
      <Hidden smDown>
        <Toolbar disableGutters className={classes.menubar}>
          <List disablePadding className={classes.navigationContainer}>
            {pagesList.map((page, i) => (
              <ListItem
                aria-describedby={page.id}
                onClick={(e) => handleClick(e, page.id)}
                className={clsx(classes.listItem, openedPopoverId === page.id ? classes.listItemActive : '')}
                key={page.id}
              >
                {page.multiple ? (
                  <>
                    <div
                      className={clsx(
                        classes.listItemText,
                        'menu-item',
                        isStatisticsNestedMenuActive && 'menu-item-active-link',
                      )}
                      color='textPrimary'
                      ref={page.multiple && anchorRef}
                      id='composition-button'
                      aria-controls={open ? 'composition-menu' : undefined}
                      aria-expanded={open ? 'true' : undefined}
                      aria-haspopup='true'
                      onClick={handleToggle}
                    >
                      {page.title}
                    </div>
                    <Popper
                      open={open}
                      anchorEl={anchorRef.current}
                      role={undefined}
                      placement='bottom-start'
                      transition
                      disablePortal
                      style={{ zIndex: '9999' }}
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
                          }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={handleClose} key={i}>
                              <MenuList
                                autoFocusItem={open}
                                id='composition-menu'
                                aria-labelledby='composition-button'
                                onKeyDown={handleListKeyDown}
                              >
                                {page.subpages.map((subpage) => (
                                  subpage.multiple ? (
                                      <MenuItem key={subpage.id}>
                                        <div
                                            color='textPrimary'
                                            className={clsx(classes.listItemText, 'menu-item')}
                                            ref={subpage.multiple && subAnchorRef}
                                            id='sub-composition-button'
                                            aria-controls={openSub ? 'composition-menu' : undefined}
                                            aria-expanded={openSub ? 'true' : undefined}
                                            aria-haspopup='true'
                                            onMouseEnter={handleToggleSub}
                                        >
                                          <span className={classes.subMenu}>
                                            {subpage.title} <ArrowRight fontSize='large'/>
                                          </span>
                                            <Popper
                                                open={openSub}
                                                anchorEl={subAnchorRef.current}
                                                role={undefined}
                                                placement='right-start'
                                                transition
                                                style={{ zIndex: '9999' }}
                                                modifiers={
                                                  {
                                                    name: 'offset',
                                                    options: {
                                                      offset: [50, 0], // [horizontal, vertical] offsets
                                                    },
                                                  }
                                                }
                                            >
                                              {({ TransitionProps, placement }) => (
                                                  <Grow
                                                      {...TransitionProps}
                                                      style={{
                                                        transformOrigin: placement === 'right-start' ? 'left top' : 'left bottom',
                                                      }}
                                                  >
                                                    <Paper>
                                                      <ClickAwayListener onClickAway={handleClose}>
                                                        <MenuList
                                                            autoFocusItem={openSub}
                                                            id='sub-composition-menu'
                                                            aria-labelledby='sub-composition-button'
                                                            onKeyDown={handleListKeyDown}
                                                        >
                                                          {subpage.subpages.map((subsubpage, i) => (
                                                              <MenuItem onClick={handleClose}>
                                                                <NavLink
                                                                    exact
                                                                    to={subsubpage.href}
                                                                    color='textPrimary'
                                                                    className={clsx(classes.listItemTextSub, 'menu-item')}
                                                                >
                                                                  {subsubpage.title}
                                                                </NavLink>
                                                              </MenuItem>
                                                          ))}
                                                        </MenuList>
                                                      </ClickAwayListener>
                                                    </Paper>
                                                  </Grow>
                                                  )
                                              }
                                            </Popper>
                                        </div>
                                      </MenuItem>
                                  ) : (
                                      <MenuItem onClick={handleClose}>
                                        <NavLink
                                            exact
                                            to={subpage.href}
                                            color='textPrimary'
                                            className={clsx(classes.listItemText, 'menu-item')}
                                        >
                                          {subpage.title}
                                        </NavLink>
                                      </MenuItem>
                                  )
                                ))}
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </>
                ) : (
                  <NavLink
                    to={page.href}
                    color='textPrimary'
                    exact
                    activeClassName={'menu-item-active-link'}
                    className={clsx(classes.listItemText, 'menu-item')}
                  >
                    {page.title}
                  </NavLink>
                )}
              </ListItem>
            ))}
          </List>
          <div className={classes.flexGrow} />
          <div
            style={{
              display: 'inline-flex',
            }}
          >
            <NavLink to={searchUrl}>
              <ActionButton variant='contained' size='small' className={clsx(classes.searchButton)}>
                {t('HOME_PAGE.SEARCH')}
              </ActionButton>
            </NavLink>
            <ActionButton
              variant='contained'
              color='primary'
              size='small'
              className={clsx(classes.loginButton)}
              href={loginUrl}
              target='_blank'
            >
              {t('HOME_PAGE.LOG_IN')}
            </ActionButton>
            <ActionButton
                variant='contained'
                color='primary'
                size='small'
                className={clsx(classes.loginButton, classes.lbmsButton)}
                href={lbmsUrl}
                target='_blank'
            >
              {t('HOME_PAGE.LBMS')}
            </ActionButton>
          </div>
        </Toolbar>
      </Hidden>
    </div>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func,
  pages: PropTypes.object.isRequired,
  themeToggler: PropTypes.func.isRequired,
  themeMode: PropTypes.string.isRequired,
};

export default Topbar;
